// extracted by mini-css-extract-plugin
export default {"root":"HoverActions_root__PVCYK","actions":"HoverActions_actions__obAzN","content":"HoverActions_content__jQ4nw"};